import img1 from "./hero-1.avif";
import img2 from "./hero-2.avif";
import img3 from "./hero-3.avif";


export const MOOD_IMAGES = [img1, img2, img3] as const;
